export default "__VITE_ASSET__ChRU0t2v__"